/** **************************************************************************************************
*
*
*     This file is created dynamically, do not edit it.
*
*
************************  ****************************************************************************** */


export const fields = {
 "ci_row_seq_label": {
  "id": "ci_row_seq_label",
  "label": "項番",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "link",
   "p": "A",
   "debug": "1"
  },
  "tab_label": "項番",
  "tab_size": 36,
  "seq_id": 1
 },
 "ci_certificate_management_number": {
  "id": "ci_certificate_management_number",
  "label": "紐付証書管理番号\r\n(自動採番)",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "B",
   "partial_required": true,
   "debug": "2",
   "table": "certificate"
  },
  "tab_label": "紐付証書管理番号\r\n(自動採番)",
  "tab_size": 218,
  "seq_id": 2
 },
 "ci_seq_id": {
  "id": "ci_seq_id",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": null,
   "debug": "2",
   "table": "certificate"
  },
  "tab_label": "",
  "tab_size": 10,
  "seq_id": 3
 },
 "ci_seq_ref": {
  "id": "ci_seq_ref",
  "label": "証書G",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "link",
   "p": "C",
   "debug": "1"
  },
  "tab_label": "証書G",
  "tab_size": 49,
  "seq_id": 4
 },
 "ad_seq_ref": {
  "id": "ad_seq_ref",
  "label": "SW枝番",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "link",
   "p": "D",
   "debug": "1"
  },
  "tab_label": "SW枝番",
  "tab_size": 62,
  "seq_id": 5
 },
 "ci_mb_department_code": {
  "id": "ci_mb_department_code",
  "label": "ライセンス所管部署コード※",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "E",
   "debug": "2",
   "table": "master_belongs"
  },
  "tab_label": "ライセンス所管部署コード※",
  "tab_size": 179,
  "seq_id": 6
 },
 "ci_licensed_department": {
  "id": "ci_licensed_department",
  "label": "ライセンス所管部署名",
  "type": "select4",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "F",
   "partial_required": true,
   "error_if_blank": true,
   "debug": "2",
   "table": "certificate_software"
  },
  "tab_label": "ライセンス所管部署名",
  "tab_size": 140,
  "seq_id": 7
 },
 "ci_mb_team_code": {
  "id": "ci_mb_team_code",
  "label": "ライセンス所管チームコード※",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "G",
   "debug": "2",
   "table": "master_belongs"
  },
  "tab_label": "ライセンス所管チームコード※",
  "tab_size": 192,
  "seq_id": 8
 },
 "ci_license_jurisdiction_team": {
  "id": "ci_license_jurisdiction_team",
  "label": "ライセンス所管チーム名",
  "type": "select4",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "H",
   "partial_required": true,
   "error_if_blank": true,
   "debug": "2",
   "table": "certificate_software"
  },
  "tab_label": "ライセンス所管チーム名",
  "tab_size": 153,
  "seq_id": 9
 },
 "ci_jurisdiction_classification": {
  "id": "ci_jurisdiction_classification",
  "label": "所管区分※\r\n(プルダウンより選択)",
  "type": "select",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "I",
   "partial_required": true,
   "error_if_blank": true,
   "debug": "2",
   "table": "certificate_software"
  },
  "tab_label": "所管区分※\r\n(プルダウンより選択)",
  "tab_size": 244,
  "seq_id": 10
 },
 "ci_ms_system_code": {
  "id": "ci_ms_system_code",
  "label": "ライセンス所管システムコード※",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "J",
   "debug": "2",
   "table": "master_system"
  },
  "tab_label": "ライセンス所管システムコード※",
  "tab_size": 205,
  "seq_id": 11
 },
 "ci_license_jurisdiction_system": {
  "id": "ci_license_jurisdiction_system",
  "label": "ライセンス所管システム名",
  "type": "select4",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "K",
   "partial_required": true,
   "error_if_blank": true,
   "debug": "2",
   "table": "certificate_software"
  },
  "tab_label": "ライセンス所管システム名",
  "tab_size": 166,
  "seq_id": 12
 },
 "ci_equipment_in_charge_system": {
  "id": "ci_equipment_in_charge_system",
  "label": "所管システム/用途",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "L",
   "partial_required": true,
   "debug": "2",
   "table": "certificate_software"
  },
  "tab_label": "所管システム/用途",
  "tab_size": 127,
  "seq_id": 13
 },
 "ci_license_certificate_type": {
  "id": "ci_license_certificate_type",
  "label": "ライセンス証書種類※",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "M",
   "partial_required": true,
   "error_if_blank": true,
   "debug": "2",
   "table": "certificate"
  },
  "tab_label": "ライセンス証書種類※",
  "tab_size": 140,
  "seq_id": 14
 },
 "ci_certificate_individual_number": {
  "id": "ci_certificate_individual_number",
  "label": "証書個別番号\r\n",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "N",
   "partial_required": true,
   "debug": "2",
   "table": "certificate"
  },
  "tab_label": "証書個別番号\r\n",
  "tab_size": 114,
  "seq_id": 15
 },
 "ci_mm_seq_id": {
  "id": "ci_mm_seq_id",
  "label": "メーカコード※",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "O",
   "debug": "2",
   "table": "master_maker"
  },
  "tab_label": "メーカコード※",
  "tab_size": 101,
  "seq_id": 16
 },
 "ci_maker": {
  "id": "ci_maker",
  "label": "メーカー名\r\n(システム登録情報)",
  "type": "select4",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "P",
   "partial_required": true,
   "error_if_blank": true,
   "debug": "2",
   "table": "certificate_software"
  },
  "tab_label": "メーカー名\r\n(システム登録情報)",
  "tab_size": 231,
  "seq_id": 17
 },
 "ci_applicant_name": {
  "id": "ci_applicant_name",
  "label": "申請者名\r\n(ﾌﾙﾈｰﾑ)※",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "Q",
   "partial_required": true,
   "error_if_blank": true,
   "debug": "2",
   "table": "certificate_software"
  },
  "tab_label": "申請者名\r\n(ﾌﾙﾈｰﾑ)※",
  "tab_size": 192,
  "seq_id": 18
 },
 "ci_management_person_name": {
  "id": "ci_management_person_name",
  "label": "管理担当者名\r\n(ﾌﾙﾈｰﾑ)※",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "R",
   "partial_required": true,
   "error_if_blank": true,
   "debug": "2",
   "table": "certificate_software"
  },
  "tab_label": "管理担当者名\r\n(ﾌﾙﾈｰﾑ)※",
  "tab_size": 218,
  "seq_id": 19
 },
 "ci_comprehensive_contract": {
  "id": "ci_comprehensive_contract",
  "label": "包括契約※\r\n(有/無)",
  "type": "select",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "S",
   "partial_required": true,
   "debug": "2",
   "table": "certificate_software"
  },
  "tab_label": "包括契約※\r\n(有/無)",
  "tab_size": 166,
  "seq_id": 20
 },
 "ci_sales_company": {
  "id": "ci_sales_company",
  "label": "販売会社",
  "type": "select4",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "T",
   "partial_required": true,
   "debug": "2",
   "table": "certificate"
  },
  "tab_label": "販売会社",
  "tab_size": 62,
  "seq_id": 21
 },
 "ci_deadline_alert": {
  "id": "ci_deadline_alert",
  "label": "期限アラート※\r\n(有/無)",
  "type": "select",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "U",
   "partial_required": true,
   "debug": "2",
   "table": "certificate_software"
  },
  "tab_label": "期限アラート※\r\n(有/無)",
  "tab_size": 192,
  "seq_id": 22
 },
 "ci_expiration_date": {
  "id": "ci_expiration_date",
  "label": "有効期限\r\n(YYYY/MM/DD)",
  "type": "date_picker",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "V",
   "partial_required": true,
   "debug": "2",
   "table": "certificate_software"
  },
  "tab_label": "有効期限\r\n(YYYY/MM/DD)",
  "tab_size": 244,
  "seq_id": 23
 },
 "ci_maintenance_deadline": {
  "id": "ci_maintenance_deadline",
  "label": "保守期限\r\n(YYYY/MM/DD)",
  "type": "date_picker",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "W",
   "partial_required": true,
   "debug": "2",
   "table": "certificate_software"
  },
  "tab_label": "保守期限\r\n(YYYY/MM/DD)",
  "tab_size": 244,
  "seq_id": 24
 },
 "ad_seq_id": {
  "id": "ad_seq_id",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": null,
   "debug": "2",
   "table": "certificate_software"
  },
  "tab_label": "",
  "tab_size": 10,
  "seq_id": 25
 },
 "ad_certificate_software_number": {
  "id": "ad_certificate_software_number",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": null,
   "debug": "2",
   "table": "certificate_software"
  },
  "tab_label": "",
  "tab_size": 10,
  "seq_id": 26
 },
 "ad_license_name": {
  "id": "ad_license_name",
  "label": "ライセンス名※\r\n証書記載の通り",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "X",
   "partial_required": true,
   "error_if_blank": true,
   "debug": "2",
   "table": "certificate_software"
  },
  "tab_label": "ライセンス名※\r\n証書記載の通り",
  "tab_size": 218,
  "seq_id": 27
 },
 "ad_ms_software_code": {
  "id": "ad_ms_software_code",
  "label": "ソフトウェアコード※",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "Y",
   "debug": "2",
   "table": "master_software"
  },
  "tab_label": "ソフトウェアコード※",
  "tab_size": 140,
  "seq_id": 28
 },
 "ad_software_name": {
  "id": "ad_software_name",
  "label": "ソフトウェア名\r\n(システム登録情報)",
  "type": "select4",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "Z",
   "partial_required": true,
   "error_if_blank": true,
   "debug": "2",
   "table": "certificate_software"
  },
  "tab_label": "ソフトウェア名\r\n(システム登録情報)",
  "tab_size": 257,
  "seq_id": 29
 },
 "ad_product_key": {
  "id": "ad_product_key",
  "label": "プロダクトキー",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "AA",
   "partial_required": true,
   "debug": "2",
   "table": "certificate_software"
  },
  "tab_label": "プロダクトキー",
  "tab_size": 101,
  "seq_id": 30
 },
 "ad_unlimited": {
  "id": "ad_unlimited",
  "label": "無制限\r\n(無制限/-)",
  "type": "select",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "AB",
   "partial_required": true,
   "debug": "2",
   "table": "certificate_software"
  },
  "tab_label": "無制限\r\n(無制限/-)",
  "tab_size": 166,
  "seq_id": 31
 },
 "ad_second": {
  "id": "ad_second",
  "label": "セカンド",
  "type": "select",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "AC",
   "partial_required": true,
   "debug": "2",
   "table": "certificate_software"
  },
  "tab_label": "セカンド",
  "tab_size": 62,
  "seq_id": 32
 },
 "ad_second_number": {
  "id": "ad_second_number",
  "label": "セカンド数",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "AD",
   "partial_required": true,
   "debug": "2",
   "table": "certificate_software"
  },
  "tab_label": "セカンド数",
  "tab_size": 75,
  "seq_id": 33
 },
 "ad_license": {
  "id": "ad_license",
  "label": "ライセンス数",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "AE",
   "partial_required": true,
   "error_if_blank": true,
   "debug": "2",
   "table": "certificate_software"
  },
  "tab_label": "ライセンス数",
  "tab_size": 88,
  "seq_id": 34
 },
 "di_row_seq_label": {
  "id": "di_row_seq_label",
  "label": "項番_1",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "link",
   "p": "AF",
   "debug": "1"
  },
  "tab_label": "項番",
  "tab_size": 36,
  "seq_id": 35
 },
 "di_device_control_number": {
  "id": "di_device_control_number",
  "label": "機器管理番号\r\n(自動採番)",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "AG",
   "partial_required": true,
   "debug": "2",
   "table": "device_embedded_information"
  },
  "tab_label": "機器管理番号\r\n(自動採番)",
  "tab_size": 192,
  "seq_id": 36
 },
 "di_seq_id": {
  "id": "di_seq_id",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": null,
   "debug": "2",
   "table": "device_embedded_information"
  },
  "tab_label": "",
  "tab_size": 10,
  "seq_id": 37
 },
 "di_seq_ref": {
  "id": "di_seq_ref",
  "label": "機器G",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "link",
   "p": "AH",
   "debug": "1"
  },
  "tab_label": "機器G",
  "tab_size": 49,
  "seq_id": 38
 },
 "di_computer_name": {
  "id": "di_computer_name",
  "label": "コンピュータ名※",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "AI",
   "partial_required": true,
   "error_if_blank": true,
   "debug": "2",
   "table": "device_embedded_information"
  },
  "tab_label": "コンピュータ名※",
  "tab_size": 114,
  "seq_id": 39
 },
 "di_virtual_environment": {
  "id": "di_virtual_environment",
  "label": "仮想環境\r\n(有/無)※",
  "type": "select",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "AJ",
   "partial_required": true,
   "error_if_blank": true,
   "debug": "2",
   "table": "device_embedded_information"
  },
  "tab_label": "仮想環境\r\n(有/無)※",
  "tab_size": 166,
  "seq_id": 40
 },
 "di_virtual_base_unit": {
  "id": "di_virtual_base_unit",
  "label": "仮想環境の親機",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "AK",
   "partial_required": true,
   "debug": "2",
   "table": "device_embedded_information"
  },
  "tab_label": "仮想環境の親機",
  "tab_size": 101,
  "seq_id": 41
 },
 "di_mb_department_code": {
  "id": "di_mb_department_code",
  "label": "機器所管部署コード※",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "AL",
   "debug": "2",
   "table": "master_belongs"
  },
  "tab_label": "機器所管部署コード※",
  "tab_size": 140,
  "seq_id": 42
 },
 "di_equipment_in_charge_department": {
  "id": "di_equipment_in_charge_department",
  "label": "機器所管部署名(システム登録情報)",
  "type": "select4",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "AM",
   "partial_required": true,
   "error_if_blank": true,
   "debug": "2",
   "table": "device_embedded_information"
  },
  "tab_label": "機器所管部署名(システム登録情報)",
  "tab_size": 231,
  "seq_id": 43
 },
 "di_mb_team_code": {
  "id": "di_mb_team_code",
  "label": "機器所管チームコード※",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "AN",
   "debug": "2",
   "table": "master_belongs"
  },
  "tab_label": "機器所管チームコード※",
  "tab_size": 153,
  "seq_id": 44
 },
 "di_equipment_in_charge_team": {
  "id": "di_equipment_in_charge_team",
  "label": "機器所管チーム名\r\n(システム登録情報)",
  "type": "select4",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "AO",
   "partial_required": true,
   "error_if_blank": true,
   "debug": "2",
   "table": "device_embedded_information"
  },
  "tab_label": "機器所管チーム名\r\n(システム登録情報)",
  "tab_size": 270,
  "seq_id": 45
 },
 "di_equipment_in_charge_classification": {
  "id": "di_equipment_in_charge_classification",
  "label": "機器所管区分※\r\n(プルダウンより選択)",
  "type": "select",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "AP",
   "partial_required": true,
   "error_if_blank": true,
   "debug": "2",
   "table": "device_embedded_information"
  },
  "tab_label": "機器所管区分※\r\n(プルダウンより選択)",
  "tab_size": 270,
  "seq_id": 46
 },
 "di_ms_system_code": {
  "id": "di_ms_system_code",
  "label": "機器所管システムコード\r\n(システム名)",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "AQ",
   "debug": "2",
   "table": "master_system"
  },
  "tab_label": "機器所管システムコード\r\n(システム名)",
  "tab_size": 270,
  "seq_id": 47
 },
 "di_equipment_in_charge_system_it": {
  "id": "di_equipment_in_charge_system_it",
  "label": "機器所管システム\r\n(システム名)",
  "type": "select4",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "AR",
   "partial_required": true,
   "error_if_blank": true,
   "debug": "2",
   "table": "device_embedded_information"
  },
  "tab_label": "機器所管システム\r\n(システム名)",
  "tab_size": 231,
  "seq_id": 48
 },
 "di_equipment_in_charge_system": {
  "id": "di_equipment_in_charge_system",
  "label": "所管システム/用途\r\n(システム名)",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "AS",
   "partial_required": true,
   "debug": "2",
   "table": "device_embedded_information"
  },
  "tab_label": "所管システム/用途\r\n(システム名)",
  "tab_size": 244,
  "seq_id": 49
 },
 "di_leasing_or_rental": {
  "id": "di_leasing_or_rental",
  "label": "リース・レンタル※\r\n(有/無)",
  "type": "select",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "AT",
   "partial_required": true,
   "error_if_blank": true,
   "debug": "2",
   "table": "device_embedded_information"
  },
  "tab_label": "リース・レンタル※\r\n(有/無)",
  "tab_size": 218,
  "seq_id": 50
 },
 "di_manufacture_name": {
  "id": "di_manufacture_name",
  "label": "メーカー名",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "AU",
   "partial_required": true,
   "error_if_blank": true,
   "debug": "2",
   "table": "device_embedded_information"
  },
  "tab_label": "メーカー名",
  "tab_size": 75,
  "seq_id": 51
 },
 "di_model_name": {
  "id": "di_model_name",
  "label": "機種名",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "AV",
   "partial_required": true,
   "error_if_blank": true,
   "debug": "2",
   "table": "device_embedded_information"
  },
  "tab_label": "機種名",
  "tab_size": 49,
  "seq_id": 52
 },
 "di_equipment_classification": {
  "id": "di_equipment_classification",
  "label": "機器区分※\r\n(プルダウンより選択)",
  "type": "select",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "AW",
   "partial_required": true,
   "error_if_blank": true,
   "debug": "2",
   "table": "device_embedded_information"
  },
  "tab_label": "機器区分※\r\n(プルダウンより選択)",
  "tab_size": 244,
  "seq_id": 53
 },
 "di_cpu_count": {
  "id": "di_cpu_count",
  "label": "CPU数",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "AX",
   "partial_required": true,
   "debug": "2",
   "table": "device_embedded_information"
  },
  "tab_label": "CPU数",
  "tab_size": 62,
  "seq_id": 54
 },
 "di_mb2_department_code": {
  "id": "di_mb2_department_code",
  "label": "設置部署コード",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "AY",
   "debug": "2",
   "table": "master_belongs"
  },
  "tab_label": "設置部署コード",
  "tab_size": 101,
  "seq_id": 55
 },
 "di_installation_department": {
  "id": "di_installation_department",
  "label": "設置部署名※",
  "type": "select4",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "AZ",
   "partial_required": true,
   "error_if_blank": true,
   "debug": "2",
   "table": "device_embedded_information"
  },
  "tab_label": "設置部署名※",
  "tab_size": 88,
  "seq_id": 56
 },
 "di_mb2_team_code": {
  "id": "di_mb2_team_code",
  "label": "設置チームコード",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "BA",
   "debug": "2",
   "table": "master_belongs"
  },
  "tab_label": "設置チームコード",
  "tab_size": 114,
  "seq_id": 57
 },
 "di_installation_team": {
  "id": "di_installation_team",
  "label": "設置チーム※",
  "type": "select4",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "BB",
   "partial_required": true,
   "error_if_blank": true,
   "debug": "2",
   "table": "device_embedded_information"
  },
  "tab_label": "設置チーム※",
  "tab_size": 88,
  "seq_id": 58
 },
 "di_installation_base": {
  "id": "di_installation_base",
  "label": "設置拠点",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "BC",
   "partial_required": true,
   "error_if_blank": true,
   "debug": "2",
   "table": "device_embedded_information"
  },
  "tab_label": "設置拠点",
  "tab_size": 62,
  "seq_id": 59
 },
 "di_floor": {
  "id": "di_floor",
  "label": "フロア",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "BD",
   "partial_required": true,
   "debug": "2",
   "table": "device_embedded_information"
  },
  "tab_label": "フロア",
  "tab_size": 49,
  "seq_id": 60
 },
 "di_user_name": {
  "id": "di_user_name",
  "label": "使用者名\r\n(ﾌﾙﾈｰﾑ)※",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "BE",
   "partial_required": true,
   "error_if_blank": true,
   "debug": "2",
   "table": "device_embedded_information"
  },
  "tab_label": "使用者名\r\n(ﾌﾙﾈｰﾑ)※",
  "tab_size": 192,
  "seq_id": 61
 },
 "di_management_person_name": {
  "id": "di_management_person_name",
  "label": "管理担当者名\r\n(ﾌﾙﾈｰﾑ)※_1",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "BF",
   "partial_required": true,
   "error_if_blank": true,
   "debug": "2",
   "table": "device_embedded_information"
  },
  "tab_label": "管理担当者名\r\n(ﾌﾙﾈｰﾑ)※",
  "tab_size": 218,
  "seq_id": 62
 },
 "di_remarks": {
  "id": "di_remarks",
  "label": "備考欄",
  "type": "text_area",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "BG",
   "partial_required": true,
   "debug": "2",
   "table": "device_embedded_information"
  },
  "tab_label": "備考欄",
  "tab_size": 49,
  "seq_id": 63
 },
 "ci_seq_ref_link": {
  "id": "ci_seq_ref_link",
  "label": "証書G_1",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "link",
   "p": "BH",
   "debug": "1"
  },
  "tab_label": "証書G",
  "tab_size": 49,
  "seq_id": 64
 },
 "ad_seq_ref_link": {
  "id": "ad_seq_ref_link",
  "label": "SW枝番_1",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "link",
   "p": "BI",
   "debug": "1"
  },
  "tab_label": "SW枝番",
  "tab_size": 62,
  "seq_id": 65
 },
 "dd_item_number": {
  "id": "dd_item_number",
  "label": "紐付け本数",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "BJ",
   "partial_required": true,
   "error_if_blank": true,
   "debug": "2",
   "table": "device_embedded_detail"
  },
  "tab_label": "紐付け本数",
  "tab_size": 75,
  "seq_id": 66
 },
 "dd_seq_id": {
  "id": "dd_seq_id",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": null,
   "debug": "2",
   "table": "device_embedded_detail"
  },
  "tab_label": "",
  "tab_size": 10,
  "seq_id": 67
 },
 "dd_associated_device_seq_id": {
  "id": "dd_associated_device_seq_id",
  "type": "input",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": null,
   "debug": "2",
   "table": "device_embedded_detail"
  },
  "tab_label": "",
  "tab_size": 10,
  "seq_id": 68
 },
 "dd_virtual_id": {
  "id": "dd_virtual_id",
  "label": "仮想\r\n(有/無)",
  "type": "select",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "BK",
   "partial_required": true,
   "debug": "2",
   "table": "device_embedded_detail"
  },
  "tab_label": "仮想\r\n(有/無)",
  "tab_size": 127,
  "seq_id": 69
 },
 "dd_software_jurisdiction": {
  "id": "dd_software_jurisdiction",
  "label": "ソフトウェア所管※",
  "type": "select",
  "import": {
   "enabled": true
  },
  "import_details": {
   "type": "field",
   "p": "BL",
   "partial_required": true,
   "error_if_blank": true,
   "debug": "2",
   "table": "device_embedded_detail"
  },
  "tab_label": "ソフトウェア所管※",
  "tab_size": 127,
  "seq_id": 70
 },
 "more_details": {
  "id": "more_details",
  "label": "詳細",
  "type": "input",
  "import_details": {
   "p": ""
  },
  "tab_label": "詳細",
  "tab_size": 36,
  "seq_id": 71
 },
 "button_options": {
  "id": "button_options",
  "history_label_name": "hide",
  "label": "要修正",
  "tab_label": "要修正",
  "type": "input",
  "import_details": {
   "p": ""
  },
  "tab_size": 70,
  "seq_id": 72
 },
 "array": [
  {
   "id": "ci_row_seq_label",
   "label": "項番",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "link",
    "p": "A",
    "debug": "1"
   },
   "tab_label": "項番",
   "tab_size": 36,
   "seq_id": 1
  },
  {
   "id": "ci_certificate_management_number",
   "label": "紐付証書管理番号\r\n(自動採番)",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "B",
    "partial_required": true,
    "debug": "2",
    "table": "certificate"
   },
   "tab_label": "紐付証書管理番号\r\n(自動採番)",
   "tab_size": 218,
   "seq_id": 2
  },
  {
   "id": "ci_seq_id",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": null,
    "debug": "2",
    "table": "certificate"
   },
   "tab_label": "",
   "tab_size": 10,
   "seq_id": 3
  },
  {
   "id": "ci_seq_ref",
   "label": "証書G",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "link",
    "p": "C",
    "debug": "1"
   },
   "tab_label": "証書G",
   "tab_size": 49,
   "seq_id": 4
  },
  {
   "id": "ad_seq_ref",
   "label": "SW枝番",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "link",
    "p": "D",
    "debug": "1"
   },
   "tab_label": "SW枝番",
   "tab_size": 62,
   "seq_id": 5
  },
  {
   "id": "ci_mb_department_code",
   "label": "ライセンス所管部署コード※",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "E",
    "debug": "2",
    "table": "master_belongs"
   },
   "tab_label": "ライセンス所管部署コード※",
   "tab_size": 179,
   "seq_id": 6
  },
  {
   "id": "ci_licensed_department",
   "label": "ライセンス所管部署名",
   "type": "select4",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "F",
    "partial_required": true,
    "error_if_blank": true,
    "debug": "2",
    "table": "certificate_software"
   },
   "tab_label": "ライセンス所管部署名",
   "tab_size": 140,
   "seq_id": 7
  },
  {
   "id": "ci_mb_team_code",
   "label": "ライセンス所管チームコード※",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "G",
    "debug": "2",
    "table": "master_belongs"
   },
   "tab_label": "ライセンス所管チームコード※",
   "tab_size": 192,
   "seq_id": 8
  },
  {
   "id": "ci_license_jurisdiction_team",
   "label": "ライセンス所管チーム名",
   "type": "select4",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "H",
    "partial_required": true,
    "error_if_blank": true,
    "debug": "2",
    "table": "certificate_software"
   },
   "tab_label": "ライセンス所管チーム名",
   "tab_size": 153,
   "seq_id": 9
  },
  {
   "id": "ci_jurisdiction_classification",
   "label": "所管区分※\r\n(プルダウンより選択)",
   "type": "select",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "I",
    "partial_required": true,
    "error_if_blank": true,
    "debug": "2",
    "table": "certificate_software"
   },
   "tab_label": "所管区分※\r\n(プルダウンより選択)",
   "tab_size": 244,
   "seq_id": 10
  },
  {
   "id": "ci_ms_system_code",
   "label": "ライセンス所管システムコード※",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "J",
    "debug": "2",
    "table": "master_system"
   },
   "tab_label": "ライセンス所管システムコード※",
   "tab_size": 205,
   "seq_id": 11
  },
  {
   "id": "ci_license_jurisdiction_system",
   "label": "ライセンス所管システム名",
   "type": "select4",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "K",
    "partial_required": true,
    "error_if_blank": true,
    "debug": "2",
    "table": "certificate_software"
   },
   "tab_label": "ライセンス所管システム名",
   "tab_size": 166,
   "seq_id": 12
  },
  {
   "id": "ci_equipment_in_charge_system",
   "label": "所管システム/用途",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "L",
    "partial_required": true,
    "debug": "2",
    "table": "certificate_software"
   },
   "tab_label": "所管システム/用途",
   "tab_size": 127,
   "seq_id": 13
  },
  {
   "id": "ci_license_certificate_type",
   "label": "ライセンス証書種類※",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "M",
    "partial_required": true,
    "error_if_blank": true,
    "debug": "2",
    "table": "certificate"
   },
   "tab_label": "ライセンス証書種類※",
   "tab_size": 140,
   "seq_id": 14
  },
  {
   "id": "ci_certificate_individual_number",
   "label": "証書個別番号\r\n",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "N",
    "partial_required": true,
    "debug": "2",
    "table": "certificate"
   },
   "tab_label": "証書個別番号\r\n",
   "tab_size": 114,
   "seq_id": 15
  },
  {
   "id": "ci_mm_seq_id",
   "label": "メーカコード※",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "O",
    "debug": "2",
    "table": "master_maker"
   },
   "tab_label": "メーカコード※",
   "tab_size": 101,
   "seq_id": 16
  },
  {
   "id": "ci_maker",
   "label": "メーカー名\r\n(システム登録情報)",
   "type": "select4",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "P",
    "partial_required": true,
    "error_if_blank": true,
    "debug": "2",
    "table": "certificate_software"
   },
   "tab_label": "メーカー名\r\n(システム登録情報)",
   "tab_size": 231,
   "seq_id": 17
  },
  {
   "id": "ci_applicant_name",
   "label": "申請者名\r\n(ﾌﾙﾈｰﾑ)※",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "Q",
    "partial_required": true,
    "error_if_blank": true,
    "debug": "2",
    "table": "certificate_software"
   },
   "tab_label": "申請者名\r\n(ﾌﾙﾈｰﾑ)※",
   "tab_size": 192,
   "seq_id": 18
  },
  {
   "id": "ci_management_person_name",
   "label": "管理担当者名\r\n(ﾌﾙﾈｰﾑ)※",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "R",
    "partial_required": true,
    "error_if_blank": true,
    "debug": "2",
    "table": "certificate_software"
   },
   "tab_label": "管理担当者名\r\n(ﾌﾙﾈｰﾑ)※",
   "tab_size": 218,
   "seq_id": 19
  },
  {
   "id": "ci_comprehensive_contract",
   "label": "包括契約※\r\n(有/無)",
   "type": "select",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "S",
    "partial_required": true,
    "debug": "2",
    "table": "certificate_software"
   },
   "tab_label": "包括契約※\r\n(有/無)",
   "tab_size": 166,
   "seq_id": 20
  },
  {
   "id": "ci_sales_company",
   "label": "販売会社",
   "type": "select4",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "T",
    "partial_required": true,
    "debug": "2",
    "table": "certificate"
   },
   "tab_label": "販売会社",
   "tab_size": 62,
   "seq_id": 21
  },
  {
   "id": "ci_deadline_alert",
   "label": "期限アラート※\r\n(有/無)",
   "type": "select",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "U",
    "partial_required": true,
    "debug": "2",
    "table": "certificate_software"
   },
   "tab_label": "期限アラート※\r\n(有/無)",
   "tab_size": 192,
   "seq_id": 22
  },
  {
   "id": "ci_expiration_date",
   "label": "有効期限\r\n(YYYY/MM/DD)",
   "type": "date_picker",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "V",
    "partial_required": true,
    "debug": "2",
    "table": "certificate_software"
   },
   "tab_label": "有効期限\r\n(YYYY/MM/DD)",
   "tab_size": 244,
   "seq_id": 23
  },
  {
   "id": "ci_maintenance_deadline",
   "label": "保守期限\r\n(YYYY/MM/DD)",
   "type": "date_picker",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "W",
    "partial_required": true,
    "debug": "2",
    "table": "certificate_software"
   },
   "tab_label": "保守期限\r\n(YYYY/MM/DD)",
   "tab_size": 244,
   "seq_id": 24
  },
  {
   "id": "ad_seq_id",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": null,
    "debug": "2",
    "table": "certificate_software"
   },
   "tab_label": "",
   "tab_size": 10,
   "seq_id": 25
  },
  {
   "id": "ad_certificate_software_number",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": null,
    "debug": "2",
    "table": "certificate_software"
   },
   "tab_label": "",
   "tab_size": 10,
   "seq_id": 26
  },
  {
   "id": "ad_license_name",
   "label": "ライセンス名※\r\n証書記載の通り",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "X",
    "partial_required": true,
    "error_if_blank": true,
    "debug": "2",
    "table": "certificate_software"
   },
   "tab_label": "ライセンス名※\r\n証書記載の通り",
   "tab_size": 218,
   "seq_id": 27
  },
  {
   "id": "ad_ms_software_code",
   "label": "ソフトウェアコード※",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "Y",
    "debug": "2",
    "table": "master_software"
   },
   "tab_label": "ソフトウェアコード※",
   "tab_size": 140,
   "seq_id": 28
  },
  {
   "id": "ad_software_name",
   "label": "ソフトウェア名\r\n(システム登録情報)",
   "type": "select4",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "Z",
    "partial_required": true,
    "error_if_blank": true,
    "debug": "2",
    "table": "certificate_software"
   },
   "tab_label": "ソフトウェア名\r\n(システム登録情報)",
   "tab_size": 257,
   "seq_id": 29
  },
  {
   "id": "ad_product_key",
   "label": "プロダクトキー",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "AA",
    "partial_required": true,
    "debug": "2",
    "table": "certificate_software"
   },
   "tab_label": "プロダクトキー",
   "tab_size": 101,
   "seq_id": 30
  },
  {
   "id": "ad_unlimited",
   "label": "無制限\r\n(無制限/-)",
   "type": "select",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "AB",
    "partial_required": true,
    "debug": "2",
    "table": "certificate_software"
   },
   "tab_label": "無制限\r\n(無制限/-)",
   "tab_size": 166,
   "seq_id": 31
  },
  {
   "id": "ad_second",
   "label": "セカンド",
   "type": "select",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "AC",
    "partial_required": true,
    "debug": "2",
    "table": "certificate_software"
   },
   "tab_label": "セカンド",
   "tab_size": 62,
   "seq_id": 32
  },
  {
   "id": "ad_second_number",
   "label": "セカンド数",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "AD",
    "partial_required": true,
    "debug": "2",
    "table": "certificate_software"
   },
   "tab_label": "セカンド数",
   "tab_size": 75,
   "seq_id": 33
  },
  {
   "id": "ad_license",
   "label": "ライセンス数",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "AE",
    "partial_required": true,
    "error_if_blank": true,
    "debug": "2",
    "table": "certificate_software"
   },
   "tab_label": "ライセンス数",
   "tab_size": 88,
   "seq_id": 34
  },
  {
   "id": "di_row_seq_label",
   "label": "項番_1",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "link",
    "p": "AF",
    "debug": "1"
   },
   "tab_label": "項番",
   "tab_size": 36,
   "seq_id": 35
  },
  {
   "id": "di_device_control_number",
   "label": "機器管理番号\r\n(自動採番)",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "AG",
    "partial_required": true,
    "debug": "2",
    "table": "device_embedded_information"
   },
   "tab_label": "機器管理番号\r\n(自動採番)",
   "tab_size": 192,
   "seq_id": 36
  },
  {
   "id": "di_seq_id",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": null,
    "debug": "2",
    "table": "device_embedded_information"
   },
   "tab_label": "",
   "tab_size": 10,
   "seq_id": 37
  },
  {
   "id": "di_seq_ref",
   "label": "機器G",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "link",
    "p": "AH",
    "debug": "1"
   },
   "tab_label": "機器G",
   "tab_size": 49,
   "seq_id": 38
  },
  {
   "id": "di_computer_name",
   "label": "コンピュータ名※",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "AI",
    "partial_required": true,
    "error_if_blank": true,
    "debug": "2",
    "table": "device_embedded_information"
   },
   "tab_label": "コンピュータ名※",
   "tab_size": 114,
   "seq_id": 39
  },
  {
   "id": "di_virtual_environment",
   "label": "仮想環境\r\n(有/無)※",
   "type": "select",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "AJ",
    "partial_required": true,
    "error_if_blank": true,
    "debug": "2",
    "table": "device_embedded_information"
   },
   "tab_label": "仮想環境\r\n(有/無)※",
   "tab_size": 166,
   "seq_id": 40
  },
  {
   "id": "di_virtual_base_unit",
   "label": "仮想環境の親機",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "AK",
    "partial_required": true,
    "debug": "2",
    "table": "device_embedded_information"
   },
   "tab_label": "仮想環境の親機",
   "tab_size": 101,
   "seq_id": 41
  },
  {
   "id": "di_mb_department_code",
   "label": "機器所管部署コード※",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "AL",
    "debug": "2",
    "table": "master_belongs"
   },
   "tab_label": "機器所管部署コード※",
   "tab_size": 140,
   "seq_id": 42
  },
  {
   "id": "di_equipment_in_charge_department",
   "label": "機器所管部署名(システム登録情報)",
   "type": "select4",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "AM",
    "partial_required": true,
    "error_if_blank": true,
    "debug": "2",
    "table": "device_embedded_information"
   },
   "tab_label": "機器所管部署名(システム登録情報)",
   "tab_size": 231,
   "seq_id": 43
  },
  {
   "id": "di_mb_team_code",
   "label": "機器所管チームコード※",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "AN",
    "debug": "2",
    "table": "master_belongs"
   },
   "tab_label": "機器所管チームコード※",
   "tab_size": 153,
   "seq_id": 44
  },
  {
   "id": "di_equipment_in_charge_team",
   "label": "機器所管チーム名\r\n(システム登録情報)",
   "type": "select4",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "AO",
    "partial_required": true,
    "error_if_blank": true,
    "debug": "2",
    "table": "device_embedded_information"
   },
   "tab_label": "機器所管チーム名\r\n(システム登録情報)",
   "tab_size": 270,
   "seq_id": 45
  },
  {
   "id": "di_equipment_in_charge_classification",
   "label": "機器所管区分※\r\n(プルダウンより選択)",
   "type": "select",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "AP",
    "partial_required": true,
    "error_if_blank": true,
    "debug": "2",
    "table": "device_embedded_information"
   },
   "tab_label": "機器所管区分※\r\n(プルダウンより選択)",
   "tab_size": 270,
   "seq_id": 46
  },
  {
   "id": "di_ms_system_code",
   "label": "機器所管システムコード\r\n(システム名)",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "AQ",
    "debug": "2",
    "table": "master_system"
   },
   "tab_label": "機器所管システムコード\r\n(システム名)",
   "tab_size": 270,
   "seq_id": 47
  },
  {
   "id": "di_equipment_in_charge_system_it",
   "label": "機器所管システム\r\n(システム名)",
   "type": "select4",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "AR",
    "partial_required": true,
    "error_if_blank": true,
    "debug": "2",
    "table": "device_embedded_information"
   },
   "tab_label": "機器所管システム\r\n(システム名)",
   "tab_size": 231,
   "seq_id": 48
  },
  {
   "id": "di_equipment_in_charge_system",
   "label": "所管システム/用途\r\n(システム名)",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "AS",
    "partial_required": true,
    "debug": "2",
    "table": "device_embedded_information"
   },
   "tab_label": "所管システム/用途\r\n(システム名)",
   "tab_size": 244,
   "seq_id": 49
  },
  {
   "id": "di_leasing_or_rental",
   "label": "リース・レンタル※\r\n(有/無)",
   "type": "select",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "AT",
    "partial_required": true,
    "error_if_blank": true,
    "debug": "2",
    "table": "device_embedded_information"
   },
   "tab_label": "リース・レンタル※\r\n(有/無)",
   "tab_size": 218,
   "seq_id": 50
  },
  {
   "id": "di_manufacture_name",
   "label": "メーカー名",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "AU",
    "partial_required": true,
    "error_if_blank": true,
    "debug": "2",
    "table": "device_embedded_information"
   },
   "tab_label": "メーカー名",
   "tab_size": 75,
   "seq_id": 51
  },
  {
   "id": "di_model_name",
   "label": "機種名",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "AV",
    "partial_required": true,
    "error_if_blank": true,
    "debug": "2",
    "table": "device_embedded_information"
   },
   "tab_label": "機種名",
   "tab_size": 49,
   "seq_id": 52
  },
  {
   "id": "di_equipment_classification",
   "label": "機器区分※\r\n(プルダウンより選択)",
   "type": "select",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "AW",
    "partial_required": true,
    "error_if_blank": true,
    "debug": "2",
    "table": "device_embedded_information"
   },
   "tab_label": "機器区分※\r\n(プルダウンより選択)",
   "tab_size": 244,
   "seq_id": 53
  },
  {
   "id": "di_cpu_count",
   "label": "CPU数",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "AX",
    "partial_required": true,
    "debug": "2",
    "table": "device_embedded_information"
   },
   "tab_label": "CPU数",
   "tab_size": 62,
   "seq_id": 54
  },
  {
   "id": "di_mb2_department_code",
   "label": "設置部署コード",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "AY",
    "debug": "2",
    "table": "master_belongs"
   },
   "tab_label": "設置部署コード",
   "tab_size": 101,
   "seq_id": 55
  },
  {
   "id": "di_installation_department",
   "label": "設置部署名※",
   "type": "select4",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "AZ",
    "partial_required": true,
    "error_if_blank": true,
    "debug": "2",
    "table": "device_embedded_information"
   },
   "tab_label": "設置部署名※",
   "tab_size": 88,
   "seq_id": 56
  },
  {
   "id": "di_mb2_team_code",
   "label": "設置チームコード",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "BA",
    "debug": "2",
    "table": "master_belongs"
   },
   "tab_label": "設置チームコード",
   "tab_size": 114,
   "seq_id": 57
  },
  {
   "id": "di_installation_team",
   "label": "設置チーム※",
   "type": "select4",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "BB",
    "partial_required": true,
    "error_if_blank": true,
    "debug": "2",
    "table": "device_embedded_information"
   },
   "tab_label": "設置チーム※",
   "tab_size": 88,
   "seq_id": 58
  },
  {
   "id": "di_installation_base",
   "label": "設置拠点",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "BC",
    "partial_required": true,
    "error_if_blank": true,
    "debug": "2",
    "table": "device_embedded_information"
   },
   "tab_label": "設置拠点",
   "tab_size": 62,
   "seq_id": 59
  },
  {
   "id": "di_floor",
   "label": "フロア",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "BD",
    "partial_required": true,
    "debug": "2",
    "table": "device_embedded_information"
   },
   "tab_label": "フロア",
   "tab_size": 49,
   "seq_id": 60
  },
  {
   "id": "di_user_name",
   "label": "使用者名\r\n(ﾌﾙﾈｰﾑ)※",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "BE",
    "partial_required": true,
    "error_if_blank": true,
    "debug": "2",
    "table": "device_embedded_information"
   },
   "tab_label": "使用者名\r\n(ﾌﾙﾈｰﾑ)※",
   "tab_size": 192,
   "seq_id": 61
  },
  {
   "id": "di_management_person_name",
   "label": "管理担当者名\r\n(ﾌﾙﾈｰﾑ)※_1",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "BF",
    "partial_required": true,
    "error_if_blank": true,
    "debug": "2",
    "table": "device_embedded_information"
   },
   "tab_label": "管理担当者名\r\n(ﾌﾙﾈｰﾑ)※",
   "tab_size": 218,
   "seq_id": 62
  },
  {
   "id": "di_remarks",
   "label": "備考欄",
   "type": "text_area",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "BG",
    "partial_required": true,
    "debug": "2",
    "table": "device_embedded_information"
   },
   "tab_label": "備考欄",
   "tab_size": 49,
   "seq_id": 63
  },
  {
   "id": "ci_seq_ref_link",
   "label": "証書G_1",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "link",
    "p": "BH",
    "debug": "1"
   },
   "tab_label": "証書G",
   "tab_size": 49,
   "seq_id": 64
  },
  {
   "id": "ad_seq_ref_link",
   "label": "SW枝番_1",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "link",
    "p": "BI",
    "debug": "1"
   },
   "tab_label": "SW枝番",
   "tab_size": 62,
   "seq_id": 65
  },
  {
   "id": "dd_item_number",
   "label": "紐付け本数",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "BJ",
    "partial_required": true,
    "error_if_blank": true,
    "debug": "2",
    "table": "device_embedded_detail"
   },
   "tab_label": "紐付け本数",
   "tab_size": 75,
   "seq_id": 66
  },
  {
   "id": "dd_seq_id",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": null,
    "debug": "2",
    "table": "device_embedded_detail"
   },
   "tab_label": "",
   "tab_size": 10,
   "seq_id": 67
  },
  {
   "id": "dd_associated_device_seq_id",
   "type": "input",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": null,
    "debug": "2",
    "table": "device_embedded_detail"
   },
   "tab_label": "",
   "tab_size": 10,
   "seq_id": 68
  },
  {
   "id": "dd_virtual_id",
   "label": "仮想\r\n(有/無)",
   "type": "select",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "BK",
    "partial_required": true,
    "debug": "2",
    "table": "device_embedded_detail"
   },
   "tab_label": "仮想\r\n(有/無)",
   "tab_size": 127,
   "seq_id": 69
  },
  {
   "id": "dd_software_jurisdiction",
   "label": "ソフトウェア所管※",
   "type": "select",
   "import": {
    "enabled": true
   },
   "import_details": {
    "type": "field",
    "p": "BL",
    "partial_required": true,
    "error_if_blank": true,
    "debug": "2",
    "table": "device_embedded_detail"
   },
   "tab_label": "ソフトウェア所管※",
   "tab_size": 127,
   "seq_id": 70
  },
  {
   "id": "more_details",
   "label": "詳細",
   "type": "input",
   "import_details": {
    "p": ""
   },
   "tab_label": "詳細",
   "tab_size": 36,
   "seq_id": 71
  },
  {
   "id": "button_options",
   "history_label_name": "hide",
   "label": "要修正",
   "tab_label": "要修正",
   "type": "input",
   "import_details": {
    "p": ""
   },
   "tab_size": 70,
   "seq_id": 72
  }
 ]
};


export const filed_types = {
 "SELECT_BOX": "select",
 "SELECT_BOX2": "select2",
 "SELECT_BOX3": "select3",
 "SELECT_BOX4": "select4",
 "RADIO_BUTTON": "radio_button",
 "INPUT": "input",
 "DATE_PICKER": "date_picker",
 "CURRENT_TIME": "current_time",
 "PASSWORD": "password",
 "TEXT_AREA": "text_area",
 "CHECKBOX": "checkbox",
 "SPACE": "space",
 "BUTTON": "button"
};





// WEBPACK FOOTER //
// ./src/rules/fields_temp_batch_import.js